module.exports = __webpack_public_path__ + "img/spinner-animated.ecc58199.svg";